<template>
  <div class="card2-wrapper">
    <div class="title-box">
      <h1 class="main-title">{{info.mainTitle}}</h1>
      <h2 class="sub-title">{{info.subTitle}}</h2>
    </div>
    <div class="content">
      <div class="item-wrapper">
        <div class="item-box" v-for="(item, index) in info.dataList" :key="item + '&' + index">
          <span class="top">{{item.intro}}</span>
          <span class="bottom">{{item.number}}</span>
        </div>
      </div>
      <p v-if="info.remark" class="remark">{{info.remark}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['info']
}
</script>

<style lang="scss" scoped>
  @import '@/style/bulma/app.sass';

  .card2-wrapper {
    padding: 36px 54px;
    background-color: rgba(250, 250, 250, 0.6);
    background-image: url('../../assets/card2-bg.png');
    background-size: 550px 260px;
    background-position: right bottom;
    background-repeat: no-repeat;
    font-family:PingFang SC;
    @include mobile {
      padding: 15px 10px;
      padding-top: 30px;
      padding-bottom: 30px;
      background-image: none;
    }

    .title-box {

      .main-title {
        font-size: 16px;
        font-weight: 600;
        color: rgba(62,64,74,1);
        text-align: center;
        @include mobile {
          font-size: 14px;
        }
      }

      .sub-title {
        font-size: 14px;
        font-weight: 400;
        color: rgba(136,136,136,1);
        text-align: center;
        margin: 0;
        @include mobile {
          font-size: 12px;
        }
      }
    }

    .content {

      .item-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 15px;
        @include mobile {
          justify-content: left;
        }

        .item-box {
          padding-top: 30px;
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 33.33%;
          @include mobile {
            width: 50%;
            margin-bottom: 10px;
          }

          .top {
            font-size: 16px;
            font-weight: 400;
            color: rgba(136,136,136,1);
          }

          .bottom {
            font-size: 25px;
            font-weight: 500;
            color: $primary3;
          }
        }
      }

      .remark {
        font-size: 12px;
        font-weight: 400;
        color: rgba(136,136,136,1);
        @include mobile {
          text-align: justify;
          padding: 0 12px;
        }
      }
    }
  }
</style>
